function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "shape0",
  transform: "matrix(-0.144000000000002 5.55111512312578e-17 -5.55111512312578e-17 -0.144000000000002 14.4548690672166 11.6287582585582)",
  fill: "currentColor",
  d: "M49.7464 27.4037C52.8171 29.2461 52.8171 32.1941 49.7464 34.0365L5.52737 60.6293C2.45661 62.4718 0 61.0592 0 57.5586L0 3.88164C0 0.380967 2.45661 -1.03158 5.52737 0.810873Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "shape1",
  transform: "matrix(-0.144000000000002 5.55111512312578e-17 -5.55111512312578e-17 -0.144000000000002 7.49511729411231 11.6287582585582)",
  fill: "currentColor",
  d: "M49.7464 27.4037C52.8171 29.2461 52.8171 32.1941 49.7464 34.0365L5.52737 60.6293C2.45661 62.4718 0 61.0592 0 57.5586L0 3.88164C0 0.380967 2.45661 -1.03158 5.52737 0.810873Z"
});

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14.4pt",
    height: "14.4pt",
    viewBox: "0 0 14.4 14.4",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.11d5ecf4.svg";
export { ForwardRef as ReactComponent };